module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step1_4-7d68246d9220eb8ee08c14f7a893e49d.png";